import React, { useState } from 'react';
import '../styles/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We\'ll get back to you soon.');
    setFormData({ name: '', email: '', company: '', message: '' });
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            Ready to start your next project? Let's discuss how we can help bring your ideas to life.
          </p>
        </div>
        
        <div className="contact-content">
          <div className="contact-info">
            <h3>Let's Connect</h3>
            <p>
              Whether you have a specific project in mind or just want to explore possibilities, 
              we're here to help. Reach out to us and let's start the conversation.
            </p>
            
            <div className="contact-items">
              <a href="https://www.linkedin.com/in/sethmoffat" target="_blank" rel="noopener noreferrer" className="contact-item">
                <img src="https://www.linkedin.com/favicon.ico" alt="LinkedIn" className="contact-favicon" />
                <div>
                  <h4>LinkedIn</h4>
                  <p>linkedin.com/in/sethmoffat</p>
                </div>
              </a>

              <a href="https://github.com/SethMoffat" target="_blank" rel="noopener noreferrer" className="contact-item">
                <img src="https://github.com/favicon.ico" alt="GitHub" className="contact-favicon" />
                <div>
                  <h4>GitHub</h4>
                  <p>github.com/SethMoffat</p>
                </div>
              </a>

              <a href="mailto:seththedeveloper@gmail.com" className="contact-item">
                <img src="https://www.google.com/s2/favicons?domain=gmail.com&sz=32" alt="Email" className="contact-favicon" />
                <div>
                  <h4>Email</h4>
                  <p>seththedeveloper@gmail.com</p>
                </div>
              </a>
            </div>
          </div>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <input
                type="text"
                name="company"
                placeholder="Company (Optional)"
                value={formData.company}
                onChange={handleChange}
              />
            </div>
            
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Tell us about your project"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            
            <button type="submit" className="btn btn-primary">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;